import { render, staticRenderFns } from "./newFormulaireDeCotation.vue?vue&type=template&id=31eb65d5&scoped=true"
import script from "./newFormulaireDeCotation.vue?vue&type=script&lang=js"
export * from "./newFormulaireDeCotation.vue?vue&type=script&lang=js"
import style0 from "./newFormulaireDeCotation.vue?vue&type=style&index=0&id=31eb65d5&prod&scoped=true&lang=css"
import style1 from "./newFormulaireDeCotation.vue?vue&type=style&index=1&id=31eb65d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eb65d5",
  null
  
)

export default component.exports